module.exports = __webpack_public_path__ + "static/media/section4div3Mainimg.f405c6d7.png";